import { render, staticRenderFns } from "./TridentRecord.vue?vue&type=template&id=5074934a&scoped=true&"
import script from "./TridentRecord.vue?vue&type=script&lang=js&"
export * from "./TridentRecord.vue?vue&type=script&lang=js&"
import style0 from "./TridentRecord.vue?vue&type=style&index=0&id=5074934a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074934a",
  null
  
)

export default component.exports